import Vue from 'vue'
import api from '@/apis/partitionArmingSchedule'
import parser from '@/models/siteArmingSchedule'
import {
  RESET_STATE,
  PROCESS_API_SUCCESS,
  PROCESS_API_FAILURE,
  UPDATE_PARTITION_ARMING_SCHEDULE_ENABLED_REQUEST,
  UPDATE_PARTITION_ARMING_SCHEDULE_ENABLED_SUCCESS,
  UPDATE_PARTITION_ARMING_SCHEDULE_ENABLED_FAILURE,
  GET_PARTITION_ARMING_SCHEDULES_REQUEST,
  GET_PARTITION_ARMING_SCHEDULES_SUCCESS,
  GET_PARTITION_ARMING_SCHEDULES_FAILURE,
  CREATE_PARTITION_ARMING_SCHEDULE_REQUEST,
  CREATE_PARTITION_ARMING_SCHEDULE_SUCCESS,
  CREATE_PARTITION_ARMING_SCHEDULE_FAILURE,
  UPDATE_PARTITION_ARMING_SCHEDULE_REQUEST,
  UPDATE_PARTITION_ARMING_SCHEDULE_SUCCESS,
  UPDATE_PARTITION_ARMING_SCHEDULE_FAILURE,
  DELETE_PARTITION_ARMING_SCHEDULE_REQUEST,
  DELETE_PARTITION_ARMING_SCHEDULE_SUCCESS,
  DELETE_PARTITION_ARMING_SCHEDULE_FAILURE,
} from '@/store/mutation-types'

let initialState = {
  partitionArmingSchedules: {},
  partitionHasArmingSchedule: {},
  partitionArmingScheduleEnabled: {},
  status: {
    updatePartitionArmingScheduleEnabled: null,
    getPartitionArmingSchedules: null,
    createPartitionArmingSchedule: null,
    updatePartitionArmingSchedule: null,
    deletePartitionArmingSchedule: null,
  },
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  partitionArmingSchedules: function (state) {
    return function (partitionId) {
      return state.partitionArmingSchedules[partitionId]
    }
  },
  partitionHasArmingSchedule: function (state) {
    return function (partitionId) {
      return state.partitionHasArmingSchedule[partitionId]
    }
  },
  isPartitionArmingScheduleEnabled: function (state, getters) {
    return function (partitionId) {
      // If user toggled locally, use that value
      if (state.partitionArmingScheduleEnabled[partitionId] !== undefined) {
        return !!state.partitionArmingScheduleEnabled[partitionId]
      }
      // Otherwise read from partition store data (GET /api/v2/sites/{siteId}/partitions)
      const siteId = getters.selectedSiteId
      const partitions = getters.sitePartitions(siteId) || []
      const partition = partitions.find(p => String(p.id) === String(partitionId))
      return partition ? !!partition.arming_schedule_enabled : false
    }
  },
  statusUpdatePartitionArmingScheduleEnabled: function (state) {
    return state.status.updatePartitionArmingScheduleEnabled
  },
  statusGetPartitionArmingSchedules: function (state) {
    return state.status.getPartitionArmingSchedules
  },
  statusCreatePartitionArmingSchedule: function (state) {
    return state.status.createPartitionArmingSchedule
  },
  statusUpdatePartitionArmingSchedule: function (state) {
    return state.status.updatePartitionArmingSchedule
  },
  statusDeletePartitionArmingSchedule: function (state) {
    return state.status.deletePartitionArmingSchedule
  },
}

// actions
const actions = {
  updatePartitionArmingScheduleEnabled: function ({commit}, {siteId, partitionId, armingScheduleEnabled}) {
    commit(UPDATE_PARTITION_ARMING_SCHEDULE_ENABLED_REQUEST)
    return new Promise((resolve, reject) => {
      api.updatePartitionArmingScheduleEnabled({siteId, partitionId, armingScheduleEnabled}).then(
        res => {
          let data = res.body
          commit(UPDATE_PARTITION_ARMING_SCHEDULE_ENABLED_SUCCESS, {data, partitionId, armingScheduleEnabled})
          resolve()
          commit(PROCESS_API_SUCCESS)
        },
        err => {
          commit(UPDATE_PARTITION_ARMING_SCHEDULE_ENABLED_FAILURE)
          reject({
            status: err.status,
            statusText: err.body,
          })
          commit(PROCESS_API_FAILURE, {
            status: err.status,
            statusText: err.body,
            origin: window.location.origin,
            err: Vue.tool.parseToStringify(err),
          })
        }
      )
    })
  },
  getPartitionArmingSchedules: function ({commit}, {siteId}) {
    commit(GET_PARTITION_ARMING_SCHEDULES_REQUEST)
    return new Promise((resolve, reject) => {
      api.getPartitionArmingSchedules({siteId}).then(
        res => {
          let data = res.body
          commit(GET_PARTITION_ARMING_SCHEDULES_SUCCESS, {data})
          resolve()
          commit(PROCESS_API_SUCCESS)
        },
        err => {
          commit(GET_PARTITION_ARMING_SCHEDULES_FAILURE)
          reject({
            status: err.status,
            statusText: err.body,
          })
          commit(PROCESS_API_FAILURE, {
            status: err.status,
            statusText: err.body,
            origin: window.location.origin,
            err: Vue.tool.parseToStringify(err),
          })
        }
      )
    })
  },
  createPartitionArmingSchedule: function ({commit}, {siteId, partitionId, scheduleArray}) {
    commit(CREATE_PARTITION_ARMING_SCHEDULE_REQUEST)
    return new Promise((resolve, reject) => {
      api.createPartitionArmingSchedule({siteId, partitionId, scheduleArray}).then(
        res => {
          let data = res.body
          commit(CREATE_PARTITION_ARMING_SCHEDULE_SUCCESS, data)
          resolve()
          commit(PROCESS_API_SUCCESS)
        },
        err => {
          commit(CREATE_PARTITION_ARMING_SCHEDULE_FAILURE)
          reject({
            status: err.status,
            statusText: err.body,
          })
          commit(PROCESS_API_FAILURE, {
            status: err.status,
            statusText: err.body,
            origin: window.location.origin,
            err: Vue.tool.parseToStringify(err),
          })
        }
      )
    })
  },
  updatePartitionArmingSchedule: function ({commit}, {siteId, partitionId, scheduleId, time}) {
    commit(UPDATE_PARTITION_ARMING_SCHEDULE_REQUEST)
    return new Promise((resolve, reject) => {
      api.updatePartitionArmingSchedule({siteId, partitionId, scheduleId, time}).then(
        res => {
          let data = res.body
          commit(UPDATE_PARTITION_ARMING_SCHEDULE_SUCCESS, data)
          resolve()
          commit(PROCESS_API_SUCCESS)
        },
        err => {
          commit(UPDATE_PARTITION_ARMING_SCHEDULE_FAILURE)
          reject({
            status: err.status,
            statusText: err.body,
          })
          commit(PROCESS_API_FAILURE, {
            status: err.status,
            statusText: err.body,
            origin: window.location.origin,
            err: Vue.tool.parseToStringify(err),
          })
        }
      )
    })
  },
  deletePartitionArmingSchedule: function ({commit}, {siteId, partitionId, scheduleId}) {
    commit(DELETE_PARTITION_ARMING_SCHEDULE_REQUEST)
    return new Promise((resolve, reject) => {
      api.deletePartitionArmingSchedule({siteId, partitionId, scheduleId}).then(
        res => {
          let data = res.body
          commit(DELETE_PARTITION_ARMING_SCHEDULE_SUCCESS, data)
          resolve()
          commit(PROCESS_API_SUCCESS)
        },
        err => {
          commit(DELETE_PARTITION_ARMING_SCHEDULE_FAILURE)
          reject({
            status: err.status,
            statusText: err.body,
          })
          commit(PROCESS_API_FAILURE, {
            status: err.status,
            statusText: err.body,
            origin: window.location.origin,
            err: Vue.tool.parseToStringify(err),
          })
        }
      )
    })
  }
}

// mutations
const mutations = {
  [RESET_STATE]: function (state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
  [UPDATE_PARTITION_ARMING_SCHEDULE_ENABLED_REQUEST]: function (state) {
    state.status.updatePartitionArmingScheduleEnabled = "requested"
  },
  [UPDATE_PARTITION_ARMING_SCHEDULE_ENABLED_SUCCESS]: function (state, {partitionId, armingScheduleEnabled}) {
    state.partitionArmingScheduleEnabled = {...state.partitionArmingScheduleEnabled, [partitionId]: !!armingScheduleEnabled}
    state.status.updatePartitionArmingScheduleEnabled = "successful"
  },
  [UPDATE_PARTITION_ARMING_SCHEDULE_ENABLED_FAILURE]: function (state) {
    state.status.updatePartitionArmingScheduleEnabled = "failed"
  },
  [GET_PARTITION_ARMING_SCHEDULES_REQUEST]: function (state) {
    state.status.getPartitionArmingSchedules = "requested"
  },
  [GET_PARTITION_ARMING_SCHEDULES_SUCCESS]: function (state, {data}) {
    // Response format: [{partition_id, arming_schedules: [...]}, ...]
    const newSchedules = {}
    const newHasSchedule = {}

    if (data instanceof Array) {
      for (let i = 0; i < data.length; i++) {
        const partition = data[i]
        const pid = partition.partition_id
        if (!pid) continue

        const scheduleItems = partition.arming_schedules || []
        const schedules = parser.parseArmingScheduleData(scheduleItems)
        newSchedules[pid] = schedules

        let hasSchedule = false
        for (const weekday in schedules) {
          if (!(schedules[weekday] instanceof Array)) continue
          if (schedules[weekday].length < 1) continue
          hasSchedule = true
          break
        }
        newHasSchedule[pid] = hasSchedule
      }
    }

    state.partitionArmingSchedules = newSchedules
    state.partitionHasArmingSchedule = newHasSchedule
    state.status.getPartitionArmingSchedules = "successful"
  },
  [GET_PARTITION_ARMING_SCHEDULES_FAILURE]: function (state) {
    state.status.getPartitionArmingSchedules = "failed"
  },
  [CREATE_PARTITION_ARMING_SCHEDULE_REQUEST]: function (state) {
    state.status.createPartitionArmingSchedule = "requested"
  },
  [CREATE_PARTITION_ARMING_SCHEDULE_SUCCESS]: function (state) {
    state.status.createPartitionArmingSchedule = "successful"
  },
  [CREATE_PARTITION_ARMING_SCHEDULE_FAILURE]: function (state) {
    state.status.createPartitionArmingSchedule = "failed"
  },
  [UPDATE_PARTITION_ARMING_SCHEDULE_REQUEST]: function (state) {
    state.status.updatePartitionArmingSchedule = "requested"
  },
  [UPDATE_PARTITION_ARMING_SCHEDULE_SUCCESS]: function (state) {
    state.status.updatePartitionArmingSchedule = "successful"
  },
  [UPDATE_PARTITION_ARMING_SCHEDULE_FAILURE]: function (state) {
    state.status.updatePartitionArmingSchedule = "failed"
  },
  [DELETE_PARTITION_ARMING_SCHEDULE_REQUEST]: function (state) {
    state.status.deletePartitionArmingSchedule = "requested"
  },
  [DELETE_PARTITION_ARMING_SCHEDULE_SUCCESS]: function (state) {
    state.status.deletePartitionArmingSchedule = "successful"
  },
  [DELETE_PARTITION_ARMING_SCHEDULE_FAILURE]: function (state) {
    state.status.deletePartitionArmingSchedule = "failed"
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
